
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32px","height":"32px","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('file_type_gitlab')]),_c('polygon',{staticStyle:{"fill":"#e24329"},attrs:{"points":"16 28.896 16 28.896 21.156 13.029 10.844 13.029 16 28.896"}}),_c('polygon',{staticStyle:{"fill":"#fc6d26"},attrs:{"points":"16 28.896 10.844 13.029 3.619 13.029 16 28.896"}}),_c('path',{staticStyle:{"fill":"#fca326"},attrs:{"d":"M3.619,13.029h0L2.052,17.851a1.067,1.067,0,0,0,.388,1.193L16,28.9,3.619,13.029Z"}}),_c('path',{staticStyle:{"fill":"#e24329"},attrs:{"d":"M3.619,13.029h7.225L7.739,3.473a.534.534,0,0,0-1.015,0L3.619,13.029Z"}}),_c('polygon',{staticStyle:{"fill":"#fc6d26"},attrs:{"points":"16 28.896 21.156 13.029 28.381 13.029 16 28.896"}}),_c('path',{staticStyle:{"fill":"#fca326"},attrs:{"d":"M28.381,13.029h0l1.567,4.822a1.067,1.067,0,0,1-.388,1.193L16,28.9,28.381,13.029Z"}}),_c('path',{staticStyle:{"fill":"#e24329"},attrs:{"d":"M28.381,13.029H21.156l3.105-9.557a.534.534,0,0,1,1.015,0l3.105,9.557Z"}})])
          )
        }
      }
    